import React, {useEffect, useState} from 'react'
import PropTypes from 'prop-types'
import { APP_NAME } from 'configs/AppConfig'
import { connect } from 'react-redux'
import { CONSOLE_VERSION, WI_CONSOLE_VERSION } from '../../version'
import {WI_CLIENT_VERSION} from '../../constants/ConstantsWI'
import {APPPACKAGENAMES} from '../../constants/Constant'
import { getAppLatestVersions } from '../../firebase/fireStore/versionControlDBMethods.js'

function Footer({ windowPaddingLeft }) {
  // const wiPermission = getWiPermission(context?.currentUser) // use wiContext next time instead context

  const [wiClientVersion, setWiClientVersion] = useState("")

  useEffect(() => {
    getAppLatestVersions().then(version => {
      console.log("VERSION_TESTING: ", version)
      if(version[APPPACKAGENAMES.WI_AGENT]){
        setWiClientVersion(version[APPPACKAGENAMES.WI_AGENT])
      }
      else{
        setWiClientVersion(WI_CLIENT_VERSION)
      }
    }).catch(err => {
      setWiClientVersion(WI_CLIENT_VERSION)
      console.log(err)
    })
  }, [])

  return (
    <footer className={`footer ${windowPaddingLeft}`}>
      <span>
        Copyright &copy; {`${new Date().getFullYear()}`}{' '}
        <span className="font-weight-semibold">{`${APP_NAME}`}</span> All rights reserved.
      </span>
      <div>zDNA Cloud: v{CONSOLE_VERSION}</div>
      <div>Wireless Insights: v{WI_CONSOLE_VERSION}</div>
      <div>WI Client: v{wiClientVersion}</div>
      <div>
        <a
          className="text-gray"
          href="https://www.zebra.com/us/en/about-zebra/company-information/legal/terms-of-use.html"
          target="_blank"
        >
          Terms & Conditions
        </a>
        <span className="mx-2 text-muted"> | </span>
        <a
          className="text-gray"
          href="https://www.zebra.com/us/en/about-zebra/company-information/legal/privacy-statement.html"
          target="_blank"
        >
          Privacy Policy
        </a>
      </div>
    </footer>
  )
}

Footer.propTypes = {
  windowPaddingLeft: PropTypes.string.isRequired,
}

const mapStateToProps = ({ theme }) => {
  const { windowPaddingLeft } = theme
  return { windowPaddingLeft }
}

export default connect(mapStateToProps)(Footer)
